import dbService from "./dbService";
import { insertOrUpdateDocument } from "./serviceUtils"; // still used elsewhere; migration uses db.put directly to avoid churn

// MIGRATION NOTE (temporary):
// The following createIndex* functions were augmented to perform a one-time migration
// from maps referencing `initialDate` to `lastEditDate`. If a design doc already uses
// lastEditDate, the update is skipped to avoid unnecessary re-indexing. This whole
// conditional block can be removed once production design docs are confirmed migrated.
// To remove: delete the conditional-fetch logic inside each createIndex* function and
// revert to always upserting (or remove the functions entirely if superseded by scripts).
// Added on: 2025-09-11

export async function initIndexes() {
  try {
    let createIndexMenufacturer = await createIndexBeaconMenufacturer();
    console.log("ReportService -> createIndexMenufacturer -> result: " + JSON.stringify(createIndexMenufacturer));

    let createIndexStatus = await createIndexSpecialStatus();
    console.log("ReportService -> createIndexStatus -> result: " + JSON.stringify(createIndexStatus));

    let createCountryCodeIndex = await createCountryCodeReportIndex();
    console.log("ReportService -> createCountryCodeIndex -> result: " + JSON.stringify(createCountryCodeIndex));

    let createOperatorLangIndex = await createOperatorLanguageReportIndex();
    console.log("ReportService -> createOperatorLangIndex -> result: " + JSON.stringify(createOperatorLangIndex));
  } catch (err) {
    console.log("ReportService -> initIndexes -> err: " + err);
  }
}

// Beacon Menufacturer Report
async function createIndexBeaconMenufacturer() {
  const db = dbService();
  const designDocId = "_design/beaconMenufacturerReport";
  const viewName = "beaconMenufacturerReport";
  const newMapFnStr = (function(doc) {
    if (doc.type !== 'beacon') return;
    if (doc.lastEditDate && doc.beaconType && doc.beaconManufacturer != "0") {
      var d, yearAndMonth;
      if (typeof(doc.lastEditDate) === 'number') {
        let createDate = new Date(doc.lastEditDate);
        let year = createDate.getFullYear();
        let month = ("0" + (createDate.getMonth() + 1)).slice(-2);
        let day = ("0" + createDate.getDate()).slice(-2);
        let hours = ("0" + createDate.getHours()).slice(-2);
        let minutes = ("0" + createDate.getMinutes()).slice(-2);
        let seconds = ("0" + createDate.getSeconds()).slice(-2);
        d = year + "-" + month + "-" + day + " " + hours + ":" + minutes + ":" + seconds;
        yearAndMonth = d.substr(0, 10);
      } else {
        yearAndMonth = doc.lastEditDate.substr(0, 10);
      }
      var beaconType = "";
      var beaconTypeSplt = doc.beaconType.split(" ");
      if (beaconTypeSplt.length > 1) {
        beaconType = beaconTypeSplt[0];
      } else {
        beaconType = doc.beaconType;
      }
      var beaconManufacturer = doc.beaconManufacturer;
      emit(yearAndMonth + "==" + beaconManufacturer + "==" + beaconType);
    }
  }).toString();

  try {
    let existing;
    try {
      existing = await db.get(designDocId);
    } catch (e) {
      if (e.status !== 404 && e.name !== 'not_found') throw e;
    }

    if (existing) {
      const existingMap = existing.views && existing.views[viewName] && existing.views[viewName].map;
      if (existingMap && existingMap.includes('lastEditDate') && !existingMap.includes('initialDate')) {
        return { designDocId, view: viewName, action: 'skipped', reason: 'already using lastEditDate' };
      }
      // migrate
      existing.views = existing.views || {};
      existing.views[viewName] = existing.views[viewName] || {};
      existing.views[viewName].map = newMapFnStr;
      existing.views[viewName].reduce = "_count";
      await db.put(existing);
      return { designDocId, view: viewName, action: 'updated', migrated: true };
    } else {
      const ddoc = {
        _id: designDocId,
        views: {
          [viewName]: {
            map: newMapFnStr,
            reduce: "_count"
          }
        }
      };
      await db.put(ddoc);
      return { designDocId, view: viewName, action: 'created' };
    }
  } catch (err) {
    console.log('log: createIndexBeaconMenufacturer -> err', err);
    return { designDocId, view: viewName, action: 'error', error: err.message };
  }
}

export async function getBeaconManufacturerReport(startDate, endDate) {
  let db = dbService();
  try {
    var result = await db.query("beaconMenufacturerReport", {
      group: true,
      include_docs: false,
      startkey: startDate,
      endkey: endDate + "\uffff",
      inclusive_end: false
    });
    // console.log('===============> report data > beaconMenufacturerReport: ' + JSON.stringify(result))
    return result;
  } catch (err) {
    console.log(err);
  }
}

// Special Status Report
async function createIndexSpecialStatus() {
  const db = dbService();
  const designDocId = "_design/specialStatusReport";
  const viewName = "specialStatusReport";
  const newMapFnStr = (function(doc) {
    if (doc.type !== 'beacon') return;
    if (doc.lastEditDate) {
      var d, yearAndMonth;
      if (typeof(doc.lastEditDate) === 'number') {
        let createDate = new Date(doc.lastEditDate);
        let year = createDate.getFullYear();
        let month = ("0" + (createDate.getMonth() + 1)).slice(-2);
        let day = ("0" + createDate.getDate()).slice(-2);
        let hours = ("0" + createDate.getHours()).slice(-2);
        let minutes = ("0" + createDate.getMinutes()).slice(-2);
        let seconds = ("0" + createDate.getSeconds()).slice(-2);
        d = year + "-" + month + "-" + day + " " + hours + ":" + minutes + ":" + seconds;
        yearAndMonth = d.substr(0, 10);
      } else {
        yearAndMonth = doc.lastEditDate.substr(0, 10);
      }
      var beaconStatus = doc.specialStatus;
      emit(yearAndMonth + "-" + beaconStatus);
    }
  }).toString();

  try {
    let existing;
    try { existing = await db.get(designDocId); } catch (e) { if (e.status !== 404 && e.name !== 'not_found') throw e; }
    if (existing) {
      const existingMap = existing.views && existing.views[viewName] && existing.views[viewName].map;
      if (existingMap && existingMap.includes('lastEditDate') && !existingMap.includes('initialDate')) {
        return { designDocId, view: viewName, action: 'skipped', reason: 'already using lastEditDate' };
      }
      existing.views = existing.views || {};
      existing.views[viewName] = existing.views[viewName] || {};
      existing.views[viewName].map = newMapFnStr;
      existing.views[viewName].reduce = "_count";
      await db.put(existing);
      return { designDocId, view: viewName, action: 'updated' };
    } else {
      const ddoc = { _id: designDocId, views: { [viewName]: { map: newMapFnStr, reduce: "_count" } } };
      await db.put(ddoc);
      return { designDocId, view: viewName, action: 'created' };
    }
  } catch (err) {
    console.log('log: createIndexSpecialStatus -> err', err);
    return { designDocId, view: viewName, action: 'error', error: err.message };
  }
}

export async function getSpecialStatusReport(startDate, endDate) {
  let db = dbService();
  try {
    var result = await db.query("specialStatusReport", {
      group: true,
      include_docs: false,
      startkey: startDate,
      endkey: endDate + "\uffff",
      inclusive_end: false
    });
    // console.log('===============> report data > getSpecialStatusReport: ' + JSON.stringify(result))
    return result;
  } catch (err) {
    console.log('log: getSpecialStatusReport -> err', err);
  }
}

// Country code report
async function createCountryCodeReportIndex() {
  const db = dbService();
  const designDocId = "_design/countryCodeReport";
  const viewName = "countryCodeReport";
  const newMapFnStr = (function(doc) {
    if (doc.type !== 'beacon') return;
    if (doc.lastEditDate && doc.beaconCountryCode) {
      var d, yearAndMonth;
      if (typeof(doc.lastEditDate) === 'number') {
        let createDate = new Date(doc.lastEditDate);
        let year = createDate.getFullYear();
        let month = ("0" + (createDate.getMonth() + 1)).slice(-2);
        let day = ("0" + createDate.getDate()).slice(-2);
        let hours = ("0" + createDate.getHours()).slice(-2);
        let minutes = ("0" + createDate.getMinutes()).slice(-2);
        let seconds = ("0" + createDate.getSeconds()).slice(-2);
        d = year + "-" + month + "-" + day + " " + hours + ":" + minutes + ":" + seconds;
        yearAndMonth = d.substr(0, 10);
      } else {
        yearAndMonth = doc.lastEditDate.substr(0, 10);
      }
      var countryCode = doc.beaconCountryCode;
      var beaconStatus = doc.specialStatus ? doc.specialStatus : "ACTIVE";
      var beaconTypeSplt = doc.beaconType.split(" ");
      var beaconType = beaconTypeSplt.length > 1 ? beaconTypeSplt[0] : doc.beaconType;
      var actualBeaconType = "unknown";
      if (doc.beaconType.indexOf("EPIRB") !== -1) actualBeaconType = "EPIRB";
      else if (doc.beaconType.indexOf("ELT") !== -1) actualBeaconType = "ELT";
      else if (doc.beaconType.indexOf("PLB") !== -1) actualBeaconType = "PLB";
      emit(yearAndMonth + "-" + countryCode + "-" + actualBeaconType + "-" + beaconStatus);
    }
  }).toString();

  try {
    let existing; try { existing = await db.get(designDocId); } catch (e) { if (e.status !== 404 && e.name !== 'not_found') throw e; }
    if (existing) {
      const existingMap = existing.views && existing.views[viewName] && existing.views[viewName].map;
      if (existingMap && existingMap.includes('lastEditDate') && !existingMap.includes('initialDate')) {
        return { designDocId, view: viewName, action: 'skipped', reason: 'already using lastEditDate' };
      }
      existing.views = existing.views || {};
      existing.views[viewName] = existing.views[viewName] || {};
      existing.views[viewName].map = newMapFnStr;
      existing.views[viewName].reduce = "_count";
      await db.put(existing);
      return { designDocId, view: viewName, action: 'updated' };
    } else {
      const ddoc = { _id: designDocId, views: { [viewName]: { map: newMapFnStr, reduce: "_count" } } };
      await db.put(ddoc);
      return { designDocId, view: viewName, action: 'created' };
    }
  } catch (err) {
    console.log('log: createCountryCodeReportIndex -> err', err);
    return { designDocId, view: viewName, action: 'error', error: err.message };
  }
}

export async function getCountryCodeReport(startDate, endDate) {
  let db = dbService();
  try {
    var result = await db.query("countryCodeReport", {
      group: true,
      include_docs: false,
      startkey: startDate,
      endkey: endDate + "\uffff",
      inclusive_end: false
    });
    console.log("===============> report data > getCountryCodeReport: ", result);
    return result;
  } catch (err) {
    console.log('log: getCountryCodeReport -> err', err);
  }
}

// Operator language report
async function createOperatorLanguageReportIndex() {
  const db = dbService();
  const designDocId = "_design/operatorLanguageReport";
  const viewName = "operatorLanguageReport";
  const newMapFnStr = (function(doc) {
    if (doc.type !== 'beacon') return;
    if (doc.lastEditDate) {
      var d, yearAndMonth;
      if (typeof(doc.lastEditDate) === 'number') {
        let createDate = new Date(doc.lastEditDate);
        let year = createDate.getFullYear();
        let month = ("0" + (createDate.getMonth() + 1)).slice(-2);
        let day = ("0" + createDate.getDate()).slice(-2);
        let hours = ("0" + createDate.getHours()).slice(-2);
        let minutes = ("0" + createDate.getMinutes()).slice(-2);
        let seconds = ("0" + createDate.getSeconds()).slice(-2);
        d = year + "-" + month + "-" + day + " " + hours + ":" + minutes + ":" + seconds;
        yearAndMonth = d.substr(0, 10);
      } else {
        yearAndMonth = doc.lastEditDate.substr(0, 10);
      }
      var operatorLanguage = doc.operatorLanguage;
      emit(yearAndMonth + "-" + operatorLanguage);
    }
  }).toString();

  try {
    let existing; try { existing = await db.get(designDocId); } catch (e) { if (e.status !== 404 && e.name !== 'not_found') throw e; }
    if (existing) {
      const existingMap = existing.views && existing.views[viewName] && existing.views[viewName].map;
      if (existingMap && existingMap.includes('lastEditDate') && !existingMap.includes('initialDate')) {
        return { designDocId, view: viewName, action: 'skipped', reason: 'already using lastEditDate' };
      }
      existing.views = existing.views || {};
      existing.views[viewName] = existing.views[viewName] || {};
      existing.views[viewName].map = newMapFnStr;
      existing.views[viewName].reduce = "_count";
      await db.put(existing);
      return { designDocId, view: viewName, action: 'updated' };
    } else {
      const ddoc = { _id: designDocId, views: { [viewName]: { map: newMapFnStr, reduce: "_count" } } };
      await db.put(ddoc);
      return { designDocId, view: viewName, action: 'created' };
    }
  } catch (err) {
    console.log('log: createOperatorLanguageReportIndex -> err', err);
    return { designDocId, view: viewName, action: 'error', error: err.message };
  }
}

export async function getOperatorLanguageReport(startDate, endDate) {
  let db = dbService();
  try {
    var result = await db.query("operatorLanguageReport", {
      group: true,
      include_docs: false,
      startkey: startDate,
      endkey: endDate + "\uffff",
      inclusive_end: false
    });
    // console.log("===============> report data > getoperatorLanguageReport: " + JSON.stringify(result));
    return result;
  } catch (err) {
    console.log(err);
  }
}
